import { render, staticRenderFns } from "./CalendarDesktop.vue?vue&type=template&id=25032003&scoped=true"
import script from "./CalendarDesktop.vue?vue&type=script&lang=js"
export * from "./CalendarDesktop.vue?vue&type=script&lang=js"
import style0 from "./CalendarDesktop.vue?vue&type=style&index=0&id=25032003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25032003",
  null
  
)

export default component.exports